import UserImage from "@/components/ui/forms/UserImage";

import {useEffect} from "react";

import {
  clearOptions,
  getCountries,
} from "@redux/slices/productSlices/optionsSlice";
import {clearView, viewUser} from "@redux/slices/userSlices/viewSlice";
import {BackButton} from "@ui/buttons/BackButton";
import {ViewField} from "@ui/forms/ViewField";
import {ViewTitle} from "@ui/forms/ViewTitle";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Spinner} from "@ui/general/Spinner";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";

import styles from "./styles.module.scss";

export const UserViewPage = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {id} = useParams();
  const {current, status} = useSelector((state) => state.user.view);

  const handleClickEdit = () => {
    navigate(`/admin-panel/users/edit/${id}`, {state: {id}});
  };

  useEffect(() => {
    dispatch(viewUser({id}));
    dispatch(getCountries());

    return () => {
      dispatch(clearView());
      dispatch(clearOptions());
    };
  }, [dispatch, id]);

  return (
    <BorderArticle style={{width: "100%"}}>
      <div className={styles.userWrapper}>
        <div className={styles.userHead}>
          <BackButton />
        </div>

        {status === "loading" ? (
          <Spinner
            width={80}
            height={80}
          />
        ) : (
          <div className={`${styles.user} ${styles.userBig}`}>
            <div className={styles.userInfo}>
              <ViewTitle
                value={current?.name}
                handleClickEdit={handleClickEdit}
              />

              <UserImage
                photoFile={current?.metadata}
                user={current}
              />
            </div>

            <div className={styles.content}>
              <ul>
                <ViewField
                  label={t("input.last_name")}
                  value={current?.lastname}
                />

                <ViewField
                  label={t("input.email")}
                  value={current?.email}
                />

                <ViewField
                  label={t("input.password")}
                  value={"**********"}
                />

                <ViewField
                  label={t("input.role")}
                  value={current?.role}
                />

                {current?.role !== "Admin" && (
                  <>
                    <ViewField
                      label={t("input.product_line")}
                      value={current?.product_line}
                    />

                    <ViewField
                      label={t("input.country")}
                      value={current?.country}
                    />

                    {current?.region && (
                      <ViewField
                        label={t("input.region")}
                        value={current?.region}
                      />
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </BorderArticle>
  );
};
